import Phaser from "phaser";

export default class SpectatorCount extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, spectatorArray, isSpectator) { //spectator array is an array of spectator objects with properties: id, username, avatarUrl
        super(scene, x, y);
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.isSpectator = isSpectator;
        this.spectatorArrayPrev = null;
        this.spectatorPfps = [];
        this.spectatorPfpMap = new Map();
        this.spectatorCountText = null;
        this.maskGraphicsArray = [];

        this.rectangle = this.scene.add.rectangle(this.x, this.y, 420*scale, 176*scale, 0xff0a54, 1).setDepth(this.depth + 1);
        if (isSpectator) {
            this.spectatorText = this.scene.add.text(this.x, this.y - 40*scale, "SPECTATOR MODE", { fontSize: 60*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' }).setOrigin(0.5, 0.5).setDepth(this.depth + 1);

        }
        else {
            this.spectatorText = this.scene.add.text(this.x, this.y - 40*scale, "SPECTATORS", { fontSize: 60*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' }).setOrigin(0.5, 0.5).setDepth(this.depth + 1);
        }
        this.liveText = this.scene.add.text(this.x - 136*scale, this.y + 36*scale, "LIVE", { fontSize: 74*scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF' }).setOrigin(0.5, 0.5).setDepth(this.depth + 1);
        this.spectatorEye = this.scene.add.image(this.x, this.y + 36*scale, 'all_images', 'spectator_eye').setScale(this.scale * 0.35).setOrigin(0.5, 0.5).setDepth(this.depth + 1);
        this.updateSpectators(spectatorArray);
    }

    updateSpectators(spectatorArray) {
        // Check if the new spectator array is different from the previous one
        if (!this.spectatorArrayPrev || JSON.stringify(spectatorArray) !== JSON.stringify(this.spectatorArrayPrev)) {
            // Clear the avatars if they were previously displayed
            this.clearAvatars();
    
            // Update the previous spectator array to a deep copy of the current array
            this.spectatorArrayPrev = JSON.parse(JSON.stringify(spectatorArray));
    
            // Create a new text object for the spectator count
            if (this.spectatorCountText) {
                this.spectatorCountText.destroy(); // Destroy the old text object
            }
            this.spectatorCountText = this.scene.add.text(
                this.x + 120 * this.scale,
                this.y + 36 * this.scale,
                spectatorArray.length.toString(),
                { fontSize: `${74 * this.scale}px`, fontFamily: "TruculentaBold", fill: '#FFFFFF' }
            ).setOrigin(0.5, 0.5).setDepth(this.depth + 1);
    
            // Load new avatars
            if (this.isSpectator) {
                // Load spectator profile pictures in a line
                for (let i = 0; i < spectatorArray.length && i < 25; i++) {
                    this.loadAvatar(spectatorArray[i].id, spectatorArray[i].avatarUrl, this.x + 300 * this.scale + (i * 130 * this.scale), this.y);
                }
            }
        }
    
        // Update the visibility of the spectator components
        this.updateVisibility(spectatorArray.length > 0);
    }
    

    clearAvatars() {
        // Destroy each avatar sprite and clear the array and map
        this.spectatorPfps.forEach(pfp => pfp.destroy());
        this.spectatorPfps = [];
        // Destroy the mask graphics and clear the mask graphics array
        this.maskGraphicsArray.forEach(maskGraphics => maskGraphics.destroy());
        this.maskGraphicsArray = []; // Clear the array after destroying the graphics
        this.spectatorPfpMap.clear();
    }

    loadAvatar(userId, avatarUrl, x, y) {
        if (!this.spectatorPfpMap.has(userId) && avatarUrl) {
            // Create the image key and immediately set it in the map
            const imageKey = `${avatarUrl}_${Date.now()}`;
            this.spectatorPfpMap.set(userId, imageKey);
    
            // Start a new load for the image
            this.scene.load.image(imageKey, avatarUrl); //adding date to prevent duplicate keys
    
            // Listen for the complete event
            this.scene.load.once('complete', () => {
                // Add the image to the scene
                const maskGraphics = this.scene.add.graphics(); 
                maskGraphics.fillStyle(0xffffff); // Set the mask color (white)
                maskGraphics.fillCircle(x, y, this.scale*50); // Define the circle's position and radius
                this.maskGraphicsArray.push(maskGraphics); // Add this line to store the mask graphics
                const mask = new Phaser.Display.Masks.GeometryMask(this, maskGraphics);
                const image = this.scene.add.image(x, y, imageKey).setScale(this.scale*1.1).setDepth(this.depth + 1).setMask(mask);  
                image.setInteractive();
                image.on('pointerdown', function(pointer) {
                    window.Phaser.SpectatorInfo = true;
                    window.Phaser.SpectatorId = userId;
                }, this);
                this.spectatorPfps.push(image);   
            });

            // Start the loading process
            this.scene.load.start();
            // this.scene.load.on("load", (imageKey) => { console.log("Loaded " + imageKey.src) });
        }
        else if (this.spectatorPfpMap.has(userId)) {
            const maskGraphics = this.scene.add.graphics();
            maskGraphics.fillStyle(0xffffff); // Set the mask color (white)
            maskGraphics.fillCircle(x, y, this.scale*70); // Define the circle's position and radius
            const mask = new Phaser.Display.Masks.GeometryMask(this, maskGraphics);
            const image = this.scene.add.image(x, y, this.spectatorPfpMap.get(userId)).setScale(this.scale).setDepth(this.depth + 1).setMask(mask);
            image.setInteractive();
                image.on('pointerdown', function(pointer) {
                    window.Phaser.SpectatorInfo = true;
                    window.Phaser.SpectatorId = userId;
                }, this);
            this.spectatorPfps.push(image);           
        }
        else if (!avatarUrl) {
            const image = this.scene.add.image(x, y, 'all_images', 'panda_pfp').setScale(this.scale*1.1).setDepth(this.depth + 1);
            image.setInteractive();
                image.on('pointerdown', function(pointer) {
                    window.Phaser.SpectatorInfo = true;
                    window.Phaser.SpectatorId = userId;
                }, this);
            this.spectatorPfps.push(image);
        }
    }

    updateVisibility(isVisible) {
        this.rectangle.setVisible(isVisible);
        this.spectatorText.setVisible(isVisible);
        this.liveText.setVisible(isVisible);
        this.spectatorEye.setVisible(isVisible);
        if (this.spectatorCountText !== null) {
            this.spectatorCountText.setVisible(isVisible);
        }
        this.spectatorPfps.forEach(element => {
            if (element) {
                element.setVisible(isVisible);
            }
        });
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("spectatorCount", function (x, y, scale, spectatorArray, isSpectator) {
    const spectatorCountInst = new SpectatorCount(this.scene, x, y, scale, spectatorArray, isSpectator);

    this.displayList.add(spectatorCountInst);
    this.updateList.add(spectatorCountInst);

    return spectatorCountInst;
})